export function msToHoursBalance(duration: number): string {
  const seconds = Math.floor((duration / 1000) % 60);
  const minutes = Math.floor((duration / (1000 * 60)) % 60);
  const hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  const hoursStr = hours < 10 ? "0" + hours : hours.toString();
  const minutesStr = minutes < 10 ? "0" + minutes : minutes.toString();
  const secondsStr = seconds < 10 ? "0" + seconds : seconds.toString();

  return `${hoursStr}:${minutesStr}:${secondsStr}`;
}

export function convertMsToHourMinSec(ms: number): string {
  const hours = Math.floor(ms / 3600000); // 1 hour = 3600000 ms
  const minutes = Math.floor((ms % 3600000) / 60000); // 1 minute = 60000 ms
  const seconds = Math.floor(((ms % 360000) % 60000) / 1000); // 1 second = 1000 ms

  // Ensure double digits for minutes and seconds
  const formattedMinutes = minutes.toString().padStart(2, "0");
  const formattedSeconds = seconds.toString().padStart(2, "0");

  // show only hours if it is more than 0
  if (hours > 0) {
    return `${hours}:${formattedMinutes}:${formattedSeconds}`;
  }

  return `${formattedMinutes}:${formattedSeconds}`;
}

export function convertMsToHourMin(ms: number): string {
  const hours = Math.floor(ms / 3600000); // 1 hour = 3600000 ms
  const minutes = Math.floor((ms % 3600000) / 60000); // 1 minute = 60000 ms

  // Ensure double digits for minutes and seconds
  const formattedMinutes = minutes.toString().padStart(2, "0");

  // show only hours if it is more than 0
  if (hours > 0) {
    return `${hours}:${formattedMinutes}`;
  }

  return formatDurationInMinutes(ms);
}

export const msToMinutesAndSeconds = (ms: number): string => {
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  const paddedSeconds = seconds < 10 ? `0${seconds}` : seconds;

  return `${minutes}:${paddedSeconds}`;
};

export const formatDurationInMinutes = (
  ms: number,
  language = "ar"
): string => {
  const minutes = Math.floor(ms / 60000);
  const formatNumber = (num: number) =>
    new Intl.NumberFormat(language).format(num);

  if (language === "ar") {
    if (minutes === 0) return "أقل من دقيقة";
    if (minutes === 1) return "دقيقة واحدة";
    if (minutes === 2) return "دقيقتان";
    if (minutes >= 3 && minutes <= 10) return `${formatNumber(minutes)} دقائق`;
    return `${formatNumber(minutes)} دقيقة`;
  } else {
    if (minutes === 0) return "Less than a minute";
    if (minutes === 1) return "1 minute";
    return `${formatNumber(minutes)} minutes`;
  }
};

export const formatFullBookDuration = (ms: number, language = "ar"): string => {
  const totalMinutes = Math.floor(ms / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  const formatNumber = (num: number) =>
    new Intl.NumberFormat(language).format(num);

  const translations = {
    en: { h: "h", m: "m" },
    ar: { h: "س", m: "د" },
  };

  const t =
    translations[language as keyof typeof translations] || translations.en;

  return `${formatNumber(hours)} ${t.h} ${formatNumber(minutes)} ${t.m}`;
};
